module.exports = __webpack_public_path__ + "static/media/inquiry.41140d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/inquiry.png
// module id = 450
// module chunks = 0